import { createContext, useContext } from 'react';
const ScrollingColumnsContext = /*#__PURE__*/createContext({
  multiColumn: false
});
export const ScrollingColumnsProvider = ScrollingColumnsContext.Provider;
export const useScrollingColumnsContext = () => {
  return useContext(ScrollingColumnsContext);
};